import { HASHRATE } from "src/api/HashrateFormatter";

export const hashrateUnitOptions = [
    {
        value: "Sol/s",
        label: HASHRATE.SOLS.unitName,
    },
    {
        value: "KSol/s",
        label: HASHRATE.KSOLS.unitName,
    },
    {
        value: "MSol/s",
        label: HASHRATE.MSOLS.unitName,
    },
    {
        value: "GSol/s",
        label: HASHRATE.GSOLS.unitName,
    }
];

export const convertToSols = (selectedUnit, value) => {
    switch (selectedUnit) {
        case "KSol/s":
            return value * HASHRATE.KSOLS.one;
        case "MSol/s":
            return value * HASHRATE.MSOLS.one;
        case "GSol/s":
            return value * HASHRATE.GSOLS.one;
        case "Sol/s":
        default:
            return value;
    }
};
